// the tone of a job status for the app's status tag; the wording is JobStatusBookingPipe's
const STATUS_TONES : { [code : string] : string } = {
  A: 'bg-warning',
  B: '',
  C: 'bg-success',
  F: 'bg-success',
  I: 'bg-primary',
  N: 'bg-warning',
  P: 'bg-warning',
  U: 'bg-warning',
  W: 'bg-primary'
};

// a booking nobody has started on has no status yet, which is to say it is booked and no further
const DEFAULT_BOOKING_STATUS : string = 'B';

// a booking with no job card yet, so its appointments can still be split or changed
export function isBookedStatus ( code : string ) : boolean {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  return statusCodeFor(code) === DEFAULT_BOOKING_STATUS;
}

export function statusCodeFor ( code : string ) : string {
  return code || DEFAULT_BOOKING_STATUS;
}

export function statusToneClass ( code : string ) : string {
  return STATUS_TONES[statusCodeFor(code)] || '';
}
